import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Avatar as MaterialAvatar } from "@material-ui/core";
import crown from "../../../assets/images/crown.svg";

const StyledAvatarWrapper = styled.div`
  position: relative;
`;

const StyledAvatar = styled(MaterialAvatar)`
  ${({ theme: { colors }, width, height, backgroundcolor, color, margin }) => `
    margin: ${margin};
    width: ${width};
    height: ${height};
    cursor: pointer;
    position: relative;
    background-color: ${colors[backgroundcolor]};
    color: ${colors[color]};
  `}
`;

const StyledCrown = styled.img`
  position: absolute;
  top: 0;
  right: 7px;
  height: 18px;
  z-index: 10;
  transform: rotate(25deg);
`;

const Avatar = ({
  width,
  height,
  backgroundcolor,
  color,
  margin,
  username,
  onClick,
  showCrown,
}) => {
  return (
    <StyledAvatarWrapper>
      {showCrown && <StyledCrown src={crown} alt="Crown" />}
      <StyledAvatar
        width={width}
        height={height}
        backgroundcolor={backgroundcolor}
        color={color}
        margin={margin}
        onClick={onClick}
        alt="Profile avatar"
      >
        {username?.substring(0, 1).toUpperCase()}
      </StyledAvatar>
    </StyledAvatarWrapper>
  );
};

Avatar.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  backgroundcolor: PropTypes.string,
  color: PropTypes.string,
  margin: PropTypes.string,
  username: PropTypes.string,
  onClick: PropTypes.func,
  showCrown: PropTypes.bool,
};

Avatar.defaultProps = {
  width: "45px",
  height: "45px",
  backgroundcolor: "green",
  color: "white",
  margin: "0 auto",
  username: "U",
  onClick: () => {},
  showCrown: false,
};

export default Avatar;
